import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import InputMask from "react-input-mask";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import AttachmentOutlinedIcon from "@mui/icons-material/AttachmentOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import { Input, Select } from "antd";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../config/firebase";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import {
  cardIconSx,
  newClientThemeVars,
} from "../../theme/globalStyle/globalStyle";
import theme from "../../theme";
import vehicleService from "../../service/vehicle.service";
import {
  focusFirstInvalidField,
  isReboqueStarted,
  isVehicleTypeRequiringReboque,
  validateReboqueForm,
  validateVehicleForm,
} from "./validation";
import DocumentField from "./components/DocumentField";
import ReboqueFormFields from "./components/ReboqueFormFields";
import VehicleTrailersSection from "./components/VehicleTrailersSection";
import {
  BODYWORK_TYPES,
  STATES_UF,
  VEHICLE_TYPES,
} from "./components/vehicle-form-constants";
import {
  createPendingStorageId,
  embeddedReboqueToForm,
  emptyReboque,
  mapEmbeddedReboquesToApiPayload,
  normalizeTrailerIds,
  patchEmbeddedReboque,
  reboqueFormToTrailerCreatePayload,
  reboqueFormToTrailerUpdatePayload,
  trailerDocToReboqueForm,
  unwrapVehicleResponse,
} from "../../util/vehicle/reboque-trailer-utils";
import { saveEmbeddedReboqueOnTractor } from "../../util/vehicle/reboque-trailer-persistence";
import "./vehicle.css";
import { useSelector } from "react-redux";
import { GlobalSuccessModal } from "../../components/modalGlobal/modalGlobal";
import { validatorCPF, validatorCNPJ } from "../../components/validators/validators";
import { useRef } from "react";

const DIALOG_TITLE_ID = "vehicle-alert-dialog-title";
const DIALOG_DESCRIPTION_ID = "vehicle-alert-dialog-description";

function parseDialogMessageItems(msg) {
  if (Array.isArray(msg)) {
    return msg.map((item) => String(item || "").trim()).filter(Boolean);
  }

  if (msg == null || msg === "") return [];

  return String(msg)
    .split(/\r?\n/)
    .map((line) => line.replace(/^[-•*]\s*/, "").trim())
    .filter((line) => {
      if (!line) return false;
      const normalized = line.toLowerCase();
      return (
        !normalized.includes("seguinte") &&
        !normalized.includes("obrigatório(s) estão vazio")
      );
    });
}

function isRequiredFieldsDialog(title) {
  return String(title || "")
    .toLowerCase()
    .includes("obrigat");
}

/** Máscara pt-BR para peso/capacidade em kg (ex.: 1000 → 1.000). */
function formatWeightMask(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (!digits) return "";
  return parseInt(digits, 10).toLocaleString("pt-BR");
}

function NewVehicle() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user);

  const canView =
    user?.permissoes?.vehicle?.isView ||
    user?.permissoes?.veiculo?.visualizar;
  const canCreate =
    user?.permissoes?.vehicle?.isCreate ||
    user?.permissoes?.veiculo?.cadastrar;
  const canEdit =
    user?.permissoes?.vehicle?.isEdit ||
    user?.permissoes?.veiculo?.editar;

  const view =
    Boolean(location.state?.viewOnly) ||
    Boolean(id && !canEdit) ||
    false;

  const [vehiclePlate, setVehiclePlate] = useState("");
  const [renavam, setRenavam] = useState("");
  const [ufVeiculo, setUfVeiculo] = useState("");
  const [documentCRLV, setDocumentCRLV] = useState("");
  const [descricaoVeiculo, setDescricaoVeiculo] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [rntrc, setRntrc] = useState("");
  const [tipoRNTRC, setTipoRNTRC] = useState("");
  const [bodyworkType, setBodyworkType] = useState("");
  const [bodyworkPlate, setBodyworkPlate] = useState("");
  const [documentAnttFrontImg, setDocumentAnttFrontImg] = useState("");
  const [pesoTara, setPesoTara] = useState("");
  const [capacidadeKG, setCapacidadeKG] = useState("");
  const [capacidadeM3, setCapacidadeM3] = useState("");
  const [tipoProprietario, setTipoProprietario] = useState("cpf");
  const [cpfoucnpj, setCpfoucnpj] = useState("");
  const [nomeProprietario, setNomeProprietario] = useState("");
  const [vehicleImg, setVehicleImg] = useState("");
  const [trailerIds, setTrailerIds] = useState([]);
  const [reboques, setReboques] = useState([]);
  const [isReboque, setIsReboque] = useState(false);
  const [reboqueForm, setReboqueForm] = useState(emptyReboque);
  const pendingStorageIdRef = useRef("");

  const [carregando, setCarregando] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [title, setTitle] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successModalTitle, setSuccessModalTitle] = useState("");
  const [cpfoucnpjError, setCpfoucnpjError] = useState("");

  const validateCpfCnpjOwner = (valor) => {
    if (!valor || valor.trim() === "") {
      setCpfoucnpjError("");
      return;
    }
    const clean = valor.replace(/\D/g, "");
    if (tipoProprietario === "cnpj") {
      if (clean.length === 14) {
        if (!validatorCNPJ(clean)) {
          setCpfoucnpjError("Esse CNPJ é inválido!");
        } else {
          setCpfoucnpjError("");
        }
      } else {
        setCpfoucnpjError("");
      }
    } else {
      if (clean.length === 11) {
        if (!validatorCPF(clean)) {
          setCpfoucnpjError("Esse CPF é inválido!");
        } else {
          setCpfoucnpjError("");
        }
      } else {
        setCpfoucnpjError("");
      }
    }
  };

  const handleCpfCnpjBlur = (valor) => {
    if (!valor || valor.trim() === "") {
      setCpfoucnpjError("");
      return;
    }
    const clean = valor.replace(/\D/g, "");
    if (tipoProprietario === "cnpj") {
      if (!validatorCNPJ(clean)) {
        setCpfoucnpjError("Esse CNPJ é inválido!");
      } else {
        setCpfoucnpjError("");
      }
    } else {
      if (!validatorCPF(clean)) {
        setCpfoucnpjError("Esse CPF é inválido!");
      } else {
        setCpfoucnpjError("");
      }
    }
  };

  useEffect(() => {
    if (!user?.permissoes) return;

    if (!id && !canCreate) {
      navigate("/vehicleList", { replace: true });
      return;
    }

    if (id && !canView && !canEdit) {
      navigate("/vehicleList", { replace: true });
    }
  }, [id, user?.permissoes, canCreate, canView, canEdit, navigate]);

  useEffect(() => {
    if (!id) {
      pendingStorageIdRef.current = createPendingStorageId();
      setIsReboque(false);
      setReboqueForm(emptyReboque());
      setFieldErrors({});
      setHasAttemptedSubmit(false);
      return;
    }

    const load = async () => {
      setCarregando(true);
      try {
        const response = await vehicleService.getById(id);
        const data = unwrapVehicleResponse(response) || response?.data?.data;
        if (!data) return;

        const asReboque = data.trailers === true;
        setIsReboque(asReboque);
        pendingStorageIdRef.current = String(id);

        if (asReboque) {
          setReboqueForm(trailerDocToReboqueForm({ ...data, id }));
          return;
        }

        const tractor = { ...data, id };

        setVehiclePlate(tractor.vehiclePlate || "");
        setRenavam(tractor.renavam || "");
        setUfVeiculo(tractor.ufVeiculo || "");
        setDocumentCRLV(tractor.documentCRLV || "");
        setDescricaoVeiculo(tractor.descricaoVeiculo || "");
        setVehicleType(tractor.vehicleType || "");
        setRntrc(tractor.rntrc || "");
        setTipoRNTRC(tractor.tipoRNTRC || "");
        setBodyworkType(tractor.bodyworkType || "");
        setBodyworkPlate(tractor.bodyworkPlate || "");
        setDocumentAnttFrontImg(tractor.documentAnttFrontImg || "");
        setPesoTara(formatWeightMask(tractor.pesoTara || ""));
        setCapacidadeKG(formatWeightMask(tractor.capacidadeKG || ""));
        setCapacidadeM3(formatWeightMask(tractor.capacidadeM3 || ""));
        setTipoProprietario(tractor.tipoProprietario || "cpf");
        setCpfoucnpj(tractor.cpfoucnpj || "");
        setNomeProprietario(tractor.nomeProprietario || "");
        setVehicleImg(tractor.vehicleImg || "");
        setTrailerIds(normalizeTrailerIds(tractor.trailerIds));
        setReboques(
          Array.isArray(tractor.reboques)
            ? tractor.reboques.map((r) => embeddedReboqueToForm(r))
            : [],
        );
      } catch (error) {
        showDialog(
          "Erro",
          error?.response?.data?.message || "Não foi possível carregar o veículo.",
        );
      } finally {
        setCarregando(false);
      }
    };

    load();
  }, [id]);

  const getFormData = () => ({
    vehiclePlate,
    renavam,
    ufVeiculo,
    documentCRLV,
    descricaoVeiculo,
    vehicleType,
    rntrc,
    tipoRNTRC,
    bodyworkType,
    bodyworkPlate,
    documentAnttFrontImg,
    pesoTara,
    capacidadeKG,
    capacidadeM3,
    tipoProprietario,
    cpfoucnpj,
    nomeProprietario,
    vehicleImg,
    trailerIds,
    reboques,
  });

  useEffect(() => {
    if (!hasAttemptedSubmit) return;

    const result = isReboque
      ? validateReboqueForm(reboqueForm)
      : validateVehicleForm(getFormData());
    setFieldErrors(result.success ? {} : result.fieldErrors);
  }, [
    hasAttemptedSubmit,
    isReboque,
    reboqueForm,
    vehiclePlate,
    renavam,
    ufVeiculo,
    documentCRLV,
    descricaoVeiculo,
    vehicleType,
    rntrc,
    tipoRNTRC,
    bodyworkType,
    bodyworkPlate,
    documentAnttFrontImg,
    pesoTara,
    capacidadeKG,
    capacidadeM3,
    tipoProprietario,
    cpfoucnpj,
    nomeProprietario,
    vehicleImg,
    trailerIds,
    reboques,
  ]);

  const handleIsReboqueChange = (checked) => {
    if (id) return;
    setIsReboque(checked);
    setFieldErrors({});
    setHasAttemptedSubmit(false);
    if (checked) {
      setReboqueForm(emptyReboque());
      if (!pendingStorageIdRef.current) {
        pendingStorageIdRef.current = createPendingStorageId();
      }
    }
  };

  const handleUploadReboqueAntt = (file) => {
    if (!file) return;
    setUploading(true);
    const storageId =
      id || pendingStorageIdRef.current || createPendingStorageId();
    pendingStorageIdRef.current = storageId;
    const storageRef = ref(storage, `vehicle/${storageId}/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on(
      "state_changed",
      () => {},
      () => {
        setUploading(false);
        showDialog("Erro", "Falha no upload do documento.");
      },
      async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        setUploading(false);
        setReboqueForm((prev) => ({ ...prev, anttReboque: url }));
      },
    );
  };

  const showDialog = (dialogTitle, dialogMsg) => {
    setTitle(dialogTitle);
    setMsg(dialogMsg);
    setOpen(true);
  };
  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    navigate("/vehicleList");
  };

  const handleClose = () => setOpen(false);

  const handleUpload = (file, onReady) => {
    if (!file) return;
    setUploading(true);
    const storageId =
      id || pendingStorageIdRef.current || createPendingStorageId();
    pendingStorageIdRef.current = storageId;
    const storageRef = ref(storage, `vehicle/${storageId}/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      () => { },
      (error) => {
        console.error(error);
        setUploading(false);
        showDialog("Erro", "Falha no upload do documento.");
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        onReady(downloadURL);
        setUploading(false);
      },
    );
  };

  const requiresReboque = isVehicleTypeRequiringReboque(vehicleType);
  const capacityFieldsDisabled = requiresReboque || view;

  const handleVehicleTypeChange = (value) => {
    setVehicleType(value);
    if (isVehicleTypeRequiringReboque(value)) {
      setPesoTara("");
      setCapacidadeKG("");
      setCapacidadeM3("");
      setBodyworkType("");
      setBodyworkPlate("");
    }
  };

  const getFieldError = (path) => fieldErrors[path] || "";

  const buildPayload = () => ({
    uidShipper: user.uidShipper || "",
    trailers: false,
    vehiclePlate,
    renavam: renavam || "",
    ufVeiculo: ufVeiculo || "",
    documentCRLV: documentCRLV || "",
    descricaoVeiculo: descricaoVeiculo || "",
    vehicleType: vehicleType || "",
    rntrc: rntrc || "",
    tipoRNTRC: tipoRNTRC || "",
    bodyworkType: bodyworkType || "",
    bodyworkPlate: bodyworkPlate || "",
    documentAnttFrontImg: documentAnttFrontImg || "",
    pesoTara: pesoTara || "",
    capacidadeKG: capacidadeKG || "",
    capacidadeM3: capacidadeM3 || "",
    tipoProprietario: tipoProprietario || "",
    cpfoucnpj: cpfoucnpj || "",
    nomeProprietario: nomeProprietario || "",
    vehicleImg: vehicleImg || "",
    trailerIds: normalizeTrailerIds(trailerIds),
    reboques: mapEmbeddedReboquesToApiPayload(reboques, isReboqueStarted),
  });

  const handleSaveEmbeddedReboque = async (reboqueId, nextData) => {
    let nextList = [];
    let nextTrailerIds = [];
    setReboques((prev) => {
      nextList = patchEmbeddedReboque(prev, reboqueId, nextData);
      return nextList;
    });
    nextTrailerIds = normalizeTrailerIds(trailerIds);

    return saveEmbeddedReboqueOnTractor({
      tractorId: id,
      reboques: nextList,
      trailerIds: nextTrailerIds,
      isStarted: isReboqueStarted,
    });
  };

  const save = async () => {
    if (view) return;
    if (id && !canEdit) {
      showDialog(
        "Sem permissão",
        isReboque
          ? "Você não tem permissão para editar reboques."
          : "Você não tem permissão para editar veículos.",
      );
      return;
    }
    if (!id && !canCreate) {
      showDialog(
        "Sem permissão",
        isReboque
          ? "Você não tem permissão para cadastrar reboques."
          : "Você não tem permissão para cadastrar veículos.",
      );
      return;
    }

    setHasAttemptedSubmit(true);

    if (isReboque) {
      const validation = validateReboqueForm(reboqueForm);
      if (!validation.success) {
        setFieldErrors(validation.fieldErrors);
        showDialog("Campos obrigatórios faltando", validation.messages);
        window.setTimeout(() => {
          focusFirstInvalidField(validation.firstFieldPath);
        }, 0);
        return;
      }

      setFieldErrors({});
      setCarregando(true);
      try {
        const vehicleId = String(id || "").trim();
        const isEditing = Boolean(vehicleId) && vehicleId !== "undefined";

        if (isEditing) {
          const payload = reboqueFormToTrailerUpdatePayload(
            reboqueForm,
            user?.uidShipper || "",
          );
          await vehicleService.update(vehicleId, payload);
          setSuccessModalTitle("Reboque atualizado com sucesso!");
        } else {
          const payload = reboqueFormToTrailerCreatePayload(
            reboqueForm,
            user?.uidShipper || "",
          );
          await vehicleService.create(payload);
          setSuccessModalTitle("Reboque cadastrado com sucesso!");
        }
        setShowSuccessModal(true);
      } catch (error) {
        const apiErrors = error?.response?.data?.errors;
        const message =
          error?.response?.data?.message ||
          (Array.isArray(apiErrors) && apiErrors[0]?.message) ||
          "Não foi possível salvar o reboque.";
        showDialog("Erro", message);
      } finally {
        setCarregando(false);
      }
      return;
    }

    const validation = validateVehicleForm(getFormData());
    if (!validation.success) {
      setFieldErrors(validation.fieldErrors);
      showDialog("Campos obrigatórios faltando", validation.messages);
      window.setTimeout(() => {
        focusFirstInvalidField(validation.firstFieldPath);
      }, 0);
      return;
    }

    setFieldErrors({});
    setCarregando(true);
    try {
      const payload = buildPayload();
      const vehicleId = String(id || "").trim();
      const isEditing = Boolean(vehicleId) && vehicleId !== "undefined";

      if (isEditing) {
        await vehicleService.update(vehicleId, payload);
        setSuccessModalTitle("Veículo atualizado com sucesso!");
      } else {
        await vehicleService.create(payload);
        setSuccessModalTitle("Veículo cadastrado com sucesso!");
      }
      setShowSuccessModal(true);
    } catch (error) {
      const apiErrors = error?.response?.data?.errors;
      const message =
        error?.response?.data?.message ||
        (Array.isArray(apiErrors) && apiErrors[0]?.message) ||
        "Não foi possível salvar o veículo.";
      showDialog("Erro", message);
    } finally {
      setCarregando(false);
    }
  };

  const pageTitle = view
    ? isReboque
      ? "Visualização de reboque"
      : "Visualização de veículo"
    : id
      ? isReboque
        ? "Editar reboque"
        : "Editar veículo"
      : isReboque
        ? "Cadastro de reboque"
        : "Cadastro de veículo";
  const pageSubtitle = view
    ? isReboque
      ? "Consulte os dados do reboque."
      : "Consulte os dados do veículo e reboques vinculados."
    : isReboque
      ? "Informe os dados do reboque para cadastro."
      : "Organize os dados do veículo, documentos e reboques em um único cadastro.";

  const dialogMessageItems = parseDialogMessageItems(msg);
  const requiredFieldsDialog = isRequiredFieldsDialog(title);
  const showErrorList =
    requiredFieldsDialog ||
    (Array.isArray(msg) && dialogMessageItems.length > 0);
  const dialogDescription = requiredFieldsDialog
    ? "Os seguintes campos obrigatórios estão vazios:"
    : null;
  const dialogBodyText = !showErrorList ? String(msg || "") : "";
  const DialogAlertIcon = requiredFieldsDialog
    ? WarningAmberRoundedIcon
    : ErrorOutlineRoundedIcon;

  return (
    <NewMiniDrawer
      divOpen={
        <Box
          className="new-vehicle-page"
          sx={pageWrapperSx}
          style={newClientThemeVars}
        >
          <Card sx={heroCardSx}>
            <CardContent sx={{ p: { xs: 2, md: 3 } }}>
              <Box className="new-vehicle-hero">
                <Stack spacing={1}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box sx={cardIconSx}>
                      <LocalShippingOutlinedIcon sx={{ color: "#ffffff" }} />
                    </Box>
                    <Typography sx={heroTitleSx}>{pageTitle}</Typography>
                  </Box>
                  <Typography sx={heroSubtitleSx}>{pageSubtitle}</Typography>
                </Stack>
                {view ? (
                  <Box sx={statusPillSx}>Somente leitura</Box>
                ) : (
                  <Box sx={statusPillSx}>
                    {id ? "Atualização" : "Novo registro"}
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>

          <Box className="new-vehicle-form">
            <SectionCard
              icon={<LocalShippingOutlinedIcon sx={{ color: "#ffffff" }} />}
              title="Tipo de cadastro"
              subtitle="Escolha se deseja cadastrar um veículo (trator) ou um reboque."
            >
              <FormControlLabel
                control={
                  <Switch
                    checked={isReboque}
                    disabled={Boolean(id) || view}
                    onChange={(e) => handleIsReboqueChange(e.target.checked)}
                    color="primary"
                  />
                }
                label="É reboque"
                sx={{ m: 0, color: "rgba(1,36,67,0.82)" }}
              />
            </SectionCard>

            {isReboque ? (
              <SectionCard
                icon={<DirectionsCarOutlinedIcon sx={{ color: "#ffffff" }} />}
                title="Dados do reboque"
                subtitle="Informações do reboque para cadastro independente."
              >
                <ReboqueFormFields
                  value={reboqueForm}
                  onChange={setReboqueForm}
                  fieldErrors={fieldErrors}
                  uploading={uploading}
                  onUploadAntt={handleUploadReboqueAntt}
                  disabled={view}
                />
              </SectionCard>
            ) : (
              <>
            <SectionCard
              icon={<DirectionsCarOutlinedIcon sx={{ color: "#ffffff" }} />}
              title="Dados do veículo"
              subtitle="Informações principais já utilizadas no cadastro de motorista."
            >
              <Box className="new-vehicle-grid">
                <Field
                  label="Placa do veículo *"
                  span={3}
                  fieldPath="vehiclePlate"
                  error={getFieldError("vehiclePlate")}
                >
                  <InputMask
                    disabled={view}
                    mask="aaa-9*99"
                    maskChar=""
                    className="form-control"
                    value={vehiclePlate}
                    onChange={(e) =>
                      setVehiclePlate(e.target.value.toUpperCase())
                    }
                  >
                    {(inputProps) => (
                      <input
                        {...inputProps}
                        aria-invalid={Boolean(getFieldError("vehiclePlate"))}
                        aria-describedby={
                          getFieldError("vehiclePlate")
                            ? "vehicle-field-vehiclePlate-error"
                            : undefined
                        }
                      />
                    )}
                  </InputMask>
                </Field>

                <Field
                  label="Renavam *"
                  span={3}
                  fieldPath="renavam"
                  error={getFieldError("renavam")}
                >
                  <Input
                    disabled={view}
                    maxLength={11}
                    status={getFieldError("renavam") ? "error" : undefined}
                    value={renavam}
                    onChange={(e) =>
                      setRenavam(e.target.value.replace(/\D/g, ""))
                    }
                    aria-invalid={Boolean(getFieldError("renavam"))}
                    aria-describedby={
                      getFieldError("renavam")
                        ? "vehicle-field-renavam-error"
                        : undefined
                    }
                  />
                </Field>

                <Field
                  label="UF Veículo *"
                  span={2}
                  fieldPath="ufVeiculo"
                  error={getFieldError("ufVeiculo")}
                >
                  <Select
                    disabled={view}
                    style={{ width: "100%" }}
                    status={getFieldError("ufVeiculo") ? "error" : undefined}
                    value={ufVeiculo || undefined}
                    placeholder="Selecione"
                    onChange={setUfVeiculo}
                    options={STATES_UF.map((s) => ({
                      value: s.value,
                      label: `${s.label} (${s.value})`,
                    }))}
                    showSearch
                    optionFilterProp="label"
                    allowClear
                    aria-invalid={Boolean(getFieldError("ufVeiculo"))}
                    aria-describedby={
                      getFieldError("ufVeiculo")
                        ? "vehicle-field-ufVeiculo-error"
                        : undefined
                    }
                  />
                </Field>

                <Field
                  label="Tipo de veículo *"
                  span={4}
                  fieldPath="vehicleType"
                  error={getFieldError("vehicleType")}
                >
                  <Select
                    disabled={view}
                    style={{ width: "100%" }}
                    status={getFieldError("vehicleType") ? "error" : undefined}
                    value={vehicleType || undefined}
                    placeholder="Selecione"
                    onChange={handleVehicleTypeChange}
                    options={VEHICLE_TYPES.map((t) => ({
                      value: t,
                      label: t,
                    }))}
                    allowClear
                    aria-invalid={Boolean(getFieldError("vehicleType"))}
                    aria-describedby={
                      getFieldError("vehicleType")
                        ? "vehicle-field-vehicleType-error"
                        : undefined
                    }
                  />
                </Field>

                <Field label="Descrição Veículo" span={6}>
                  <Input
                    disabled={view}
                    maxLength={200}
                    value={descricaoVeiculo}
                    onChange={(e) => setDescricaoVeiculo(e.target.value)}
                  />
                </Field>

                <Field
                  label="RNTRC *"
                  span={2}
                  fieldPath="rntrc"
                  error={getFieldError("rntrc")}
                >
                  <Input
                    disabled={view}
                    maxLength={8}
                    status={getFieldError("rntrc") ? "error" : undefined}
                    value={rntrc}
                    onChange={(e) =>
                      setRntrc(e.target.value.replace(/\D/g, ""))
                    }
                    aria-invalid={Boolean(getFieldError("rntrc"))}
                    aria-describedby={
                      getFieldError("rntrc")
                        ? "vehicle-field-rntrc-error"
                        : undefined
                    }
                  />
                </Field>

                <Field
                  label="Tipo RNTRC *"
                  span={2}
                  fieldPath="tipoRNTRC"
                  error={getFieldError("tipoRNTRC")}
                >
                  <Select
                    disabled={view}
                    style={{ width: "100%" }}
                    status={getFieldError("tipoRNTRC") ? "error" : undefined}
                    value={tipoRNTRC || undefined}
                    placeholder="Selecione"
                    onChange={setTipoRNTRC}
                    options={[
                      { value: "tac", label: "TAC" },
                      { value: "etc", label: "ETC" },
                      { value: "ctc", label: "CTC" },
                    ]}
                    allowClear
                    aria-invalid={Boolean(getFieldError("tipoRNTRC"))}
                    aria-describedby={
                      getFieldError("tipoRNTRC")
                        ? "vehicle-field-tipoRNTRC-error"
                        : undefined
                    }
                  />
                </Field>

                <Field
                  label={requiresReboque ? "Tipo Carroceria" : "Tipo Carroceria *"}
                  span={3}
                  fieldPath="bodyworkType"
                  error={getFieldError("bodyworkType")}
                >
                  <Select
                    disabled={capacityFieldsDisabled}
                    style={{ width: "100%" }}
                    status={getFieldError("bodyworkType") ? "error" : undefined}
                    value={bodyworkType || undefined}
                    placeholder="Selecione"
                    onChange={setBodyworkType}
                    options={BODYWORK_TYPES.map((t) => ({
                      value: t,
                      label: t,
                    }))}
                    allowClear
                    aria-invalid={Boolean(getFieldError("bodyworkType"))}
                    aria-describedby={
                      getFieldError("bodyworkType")
                        ? "vehicle-field-bodyworkType-error"
                        : undefined
                    }
                  />
                </Field>

                <Field label="Placa carroceria" span={3}>
                  <InputMask
                    disabled={capacityFieldsDisabled}
                    mask="aaa-9*99"
                    maskChar=""
                    className="form-control"
                    value={bodyworkPlate}
                    onChange={(e) =>
                      setBodyworkPlate(e.target.value.toUpperCase())
                    }
                  >
                    {(inputProps) => <input {...inputProps} />}
                  </InputMask>
                </Field>

                <Field label="Peso (Tara)" span={2}>
                  <Input
                    disabled={capacityFieldsDisabled}
                    value={pesoTara}
                    onChange={(e) => setPesoTara(formatWeightMask(e.target.value))}
                  />
                </Field>

                <Field label="Capacidade (KG)" span={2}>
                  <Input
                    disabled={capacityFieldsDisabled}
                    value={capacidadeKG}
                    onChange={(e) =>
                      setCapacidadeKG(formatWeightMask(e.target.value))
                    }
                  />
                </Field>

                <Field label="Capacidade (M³)" span={2}>
                  <Input
                    disabled={capacityFieldsDisabled}
                    value={capacidadeM3}
                    onChange={(e) =>
                      setCapacidadeM3(formatWeightMask(e.target.value))
                    }
                  />
                </Field>

                <Field label="Tipo Proprietário" span={2}>
                  <Select
                    disabled={view}
                    style={{ width: "100%" }}
                    value={tipoProprietario || undefined}
                    onChange={setTipoProprietario}
                    options={[
                      { value: "cpf", label: "CPF" },
                      { value: "cnpj", label: "CNPJ" },
                    ]}
                  />
                </Field>

                <Field
                  label={
                    tipoProprietario === "cnpj"
                      ? "CNPJ Proprietário"
                      : "CPF Proprietário"
                  }
                  span={4}
                >
                  <InputMask
                    disabled={view}
                    mask={
                      tipoProprietario === "cnpj"
                        ? "99.999.999/9999-99"
                        : "999.999.999-99"
                    }
                    maskChar=""
                    className="form-control"
                    placeholder={
                      tipoProprietario === "cnpj"
                        ? "00.000.000/0000-00"
                        : "000.000.000-00"
                    }
                    value={cpfoucnpj}
                    onChange={(e) => {
                      const val = e.target.value;
                      setCpfoucnpj(val);
                      validateCpfCnpjOwner(val);
                    }}
                    onBlur={(e) => handleCpfCnpjBlur(e.target.value)}
                  >
                    {(inputProps) => <input {...inputProps} />}
                  </InputMask>
                  {cpfoucnpjError && (
                    <small style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                      {cpfoucnpjError}
                    </small>
                  )}
                </Field>

                <Field label="Nome Proprietário" span={6}>
                  <Input
                    disabled={view}
                    value={nomeProprietario}
                    onChange={(e) => setNomeProprietario(e.target.value)}
                  />
                </Field>
              </Box>
            </SectionCard>

            <SectionCard
              icon={<AttachmentOutlinedIcon sx={{ color: "#ffffff" }} />}
              title="Documentos"
              subtitle="CRLV e Doc ANTT seguem o mesmo padrão do cadastro de motorista (URL no Storage)."
            >
              <Box className="new-vehicle-grid">
                <Field
                  label="CRLV *"
                  span={6}
                  fieldPath="documentCRLV"
                  error={getFieldError("documentCRLV")}
                >
                  <DocumentField
                    url={documentCRLV}
                    disabled={view || uploading}
                    error={Boolean(getFieldError("documentCRLV"))}
                    errorId="vehicle-field-documentCRLV-error"
                    onUpload={(file) =>
                      handleUpload(file, setDocumentCRLV)
                    }
                    onClear={() => setDocumentCRLV("")}
                  />
                </Field>
                <Field
                  label="Doc ANTT *"
                  span={6}
                  fieldPath="documentAnttFrontImg"
                  error={getFieldError("documentAnttFrontImg")}
                >
                  <DocumentField
                    url={documentAnttFrontImg}
                    disabled={view || uploading}
                    error={Boolean(getFieldError("documentAnttFrontImg"))}
                    errorId="vehicle-field-documentAnttFrontImg-error"
                    onUpload={(file) =>
                      handleUpload(file, setDocumentAnttFrontImg)
                    }
                    onClear={() => setDocumentAnttFrontImg("")}
                  />
                </Field>
                <Field label="Imagem do veículo" span={6}>
                  <DocumentField
                    url={vehicleImg}
                    disabled={view || uploading}
                    onUpload={(file) => handleUpload(file, setVehicleImg)}
                    onClear={() => setVehicleImg("")}
                  />
                </Field>
              </Box>
            </SectionCard>

            <SectionCard
              icon={<LocalShippingOutlinedIcon sx={{ color: "#ffffff" }} />}
              title="Reboques"
              subtitle={
                requiresReboque
                  ? "Este tipo de veículo exige pelo menos 1 reboque vinculado."
                  : "Selecione nenhum, um ou vários reboques existentes."
              }
            >
              {view ? (
                <Typography sx={{ color: "rgba(1,36,67,0.62)", fontSize: 14 }}>
                  {normalizeTrailerIds(trailerIds).length + reboques.length === 0
                    ? "Nenhum reboque vinculado."
                    : `${normalizeTrailerIds(trailerIds).length + reboques.length} reboque(s) vinculado(s).`}
                </Typography>
              ) : (
                <VehicleTrailersSection
                  trailerIds={trailerIds}
                  embeddedReboques={reboques}
                  onTrailerIdsChange={(ids) =>
                    setTrailerIds(normalizeTrailerIds(ids))
                  }
                  onEmbeddedReboquesChange={setReboques}
                  requiresReboque={requiresReboque}
                  selectionError={
                    getFieldError("trailerIds") || getFieldError("reboques")
                  }
                  tractorVehicleId={id || ""}
                  onSaveEmbedded={handleSaveEmbeddedReboque}
                />
              )}
            </SectionCard>
              </>
            )}

            <Card sx={actionsCardSx}>
              <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                <Box className="new-vehicle-actions">
                  <Button
                    component={Link}
                    to="/vehicleList"
                    variant="outlined"
                    startIcon={<ArrowBackOutlinedIcon />}
                    sx={secondaryActionSx}
                  >
                    Voltar
                  </Button>
                  <Button
                    disabled={view || carregando || uploading}
                    variant="contained"
                    startIcon={
                      carregando ? (
                        <CircularProgress color="inherit" size={16} />
                      ) : (
                        <SaveOutlinedIcon />
                      )
                    }
                    onClick={save}
                    sx={primaryActionSx}
                  >
                    {carregando
                      ? id
                        ? "Atualizando..."
                        : "Criando..."
                      : id
                        ? "Atualizar"
                        : isReboque
                          ? "Criar reboque"
                          : "Criar"}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Dialog
            open={open}
            onClose={handleClose}
            role="dialog"
            aria-modal="true"
            aria-labelledby={DIALOG_TITLE_ID}
            aria-describedby={DIALOG_DESCRIPTION_ID}
            fullWidth
            maxWidth="sm"
            scroll="paper"
            BackdropProps={{
              sx: dialogBackdropSx,
            }}
            PaperProps={{
              sx: dialogPaperSx,
            }}
          >
            <Box sx={dialogHeaderSx}>
              <Box sx={dialogIconWrapSx}>
                <DialogAlertIcon
                  sx={{
                    fontSize: 26,
                    color: theme.colors.highlight,
                  }}
                />
              </Box>
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                  id={DIALOG_TITLE_ID}
                  component="h2"
                  sx={dialogTitleSx}
                >
                  {title || "Atenção"}
                </Typography>
                {dialogDescription ? (
                  <Typography
                    id={DIALOG_DESCRIPTION_ID}
                    sx={dialogSubtitleSx}
                  >
                    {dialogDescription}
                  </Typography>
                ) : null}
              </Box>
            </Box>

            <DialogContent
              id={dialogDescription ? undefined : DIALOG_DESCRIPTION_ID}
              sx={dialogContentSx}
            >
              {showErrorList ? (
                <Box
                  component="ul"
                  sx={dialogErrorListSx}
                  aria-label="Lista de campos obrigatórios"
                >
                  {dialogMessageItems.map((item, index) => (
                    <Box
                      component="li"
                      key={`${item}-${index}`}
                      sx={dialogErrorItemSx}
                    >
                      <Box component="span" sx={dialogErrorBulletSx} />
                      <Typography component="span" sx={dialogErrorTextSx}>
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography sx={dialogBodyTextSx}>{dialogBodyText}</Typography>
              )}
            </DialogContent>

            <Divider sx={{ borderColor: theme.colors.primaryBorder }} />

            <DialogActions sx={dialogActionsSx}>
              <Button
                onClick={handleClose}
                variant="contained"
                autoFocus
                disableElevation
                sx={dialogPrimaryButtonSx}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>

          <GlobalSuccessModal
            open={showSuccessModal}
            handleClose={handleSuccessModalClose}
            title={successModalTitle}
          />
        </Box>
      }
    />
  );
}

function SectionCard({ icon, title, subtitle, children }) {
  return (
    <Card sx={sectionCardSx}>
      <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
        <Box className="new-vehicle-section-heading">
          <Box sx={cardIconSx}>{icon}</Box>
          <Box>
            <Typography sx={sectionTitleSx}>{title}</Typography>
            <Typography sx={sectionSubtitleSx}>{subtitle}</Typography>
          </Box>
        </Box>
        <Divider sx={{ mb: 2, borderColor: "rgba(1, 36, 67, 0.10)" }} />
        {children}
      </CardContent>
    </Card>
  );
}

function Field({ label, span = 3, error, fieldPath, children }) {
  const errorId = fieldPath
    ? `vehicle-field-${String(fieldPath).replace(/\./g, "-")}-error`
    : undefined;

  return (
    <div
      className={`new-vehicle-field new-vehicle-span-${span}${error ? " has-error" : ""}`}
      data-field-path={fieldPath || undefined}
    >
      <label>{label}</label>
      {children}
      {error ? (
        <span id={errorId} className="new-vehicle-field-error" role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}

export default NewVehicle;

const pageWrapperSx = {
  p: { xs: 2, md: 3 },
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

const heroCardSx = {
  borderRadius: "18px",
  border: "1px solid var(--new-client-primary-border)",
  boxShadow: "var(--new-client-shadow-soft)",
};

const sectionCardSx = {
  borderRadius: "var(--new-client-radius-lg)",
  border: "1px solid var(--new-client-primary-border)",
  boxShadow: "var(--new-client-shadow-section)",
  background: "var(--new-client-surface-soft)",
};

const actionsCardSx = {
  borderRadius: "var(--new-client-radius-lg)",
  border: "1px solid var(--new-client-primary-border)",
  boxShadow: "var(--new-client-shadow-section)",
};

const heroTitleSx = {
  color: "var(--new-client-primary)",
  fontWeight: 700,
  fontSize: "1.25rem",
};

const heroSubtitleSx = {
  color: "rgba(1, 36, 67, 0.74)",
  fontSize: "0.92rem",
  lineHeight: 1.5,
  maxWidth: 760,
};

const sectionTitleSx = {
  color: "var(--new-client-primary)",
  fontWeight: 700,
  fontSize: "1.05rem",
};

const sectionSubtitleSx = {
  color: "rgba(1, 36, 67, 0.62)",
  fontSize: "0.79rem",
  lineHeight: 1.45,
};

const statusPillSx = {
  border: "1px solid var(--new-client-primary-border)",
  borderRadius: "999px",
  color: "var(--new-client-primary)",
  background: "var(--new-client-primary-soft)",
  px: 1.5,
  py: 0.5,
  fontSize: "0.78rem",
  fontWeight: 600,
  whiteSpace: "nowrap",
};

const primaryActionSx = {
  textTransform: "none",
  fontWeight: theme.typography.weightSemibold,
  borderRadius: `${theme.radius.medium - 2}px`,
  backgroundColor: "var(--new-client-primary)",
  minHeight: 40,
  px: 2,
  "&:hover": {
    backgroundColor: "var(--new-client-primary-hover)",
  },
};

const secondaryActionSx = {
  textTransform: "none",
  fontWeight: theme.typography.weightSemibold,
  borderRadius: `${theme.radius.medium - 2}px`,
  minHeight: 40,
  color: "var(--new-client-primary)",
  borderColor: "var(--new-client-primary-border)",
};

const dialogBackdropSx = {
  backgroundColor: "rgba(1, 36, 66, 0.48)",
  backdropFilter: "blur(4px)",
  WebkitBackdropFilter: "blur(4px)",
};

const dialogPaperSx = {
  borderRadius: `${theme.radius.large}px`,
  backgroundColor: theme.colors.surface,
  boxShadow: "0 18px 40px rgba(1, 36, 66, 0.18)",
  overflow: "hidden",
  width: "100%",
  maxWidth: 520,
  mx: { xs: 2, sm: 3 },
  my: { xs: 2, sm: 3 },
  maxHeight: "min(88vh, 640px)",
  display: "flex",
  flexDirection: "column",
  transition: theme.motion.transition,
};

const dialogHeaderSx = {
  display: "flex",
  alignItems: "flex-start",
  gap: `${theme.spacing.sm}px`,
  px: { xs: 2, sm: 2.5 },
  pt: { xs: 2, sm: 2.5 },
  pb: { xs: 1.5, sm: 2 },
  backgroundColor: theme.colors.highlightSoft,
  borderBottom: `1px solid ${theme.colors.primaryBorder}`,
};

const dialogIconWrapSx = {
  width: 44,
  height: 44,
  borderRadius: "50%",
  backgroundColor: theme.colors.surface,
  border: `1px solid ${theme.colors.primaryBorder}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  boxShadow: "0 4px 12px rgba(1, 36, 66, 0.08)",
};

const dialogTitleSx = {
  color: theme.colors.primary,
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.weightBold,
  fontSize: { xs: "1.05rem", sm: "1.2rem" },
  lineHeight: 1.3,
  letterSpacing: theme.typography.letterSpacing,
};

const dialogSubtitleSx = {
  mt: 0.5,
  color: theme.colors.textSecondary,
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.weightRegular,
  fontSize: theme.typography.bodySize,
  lineHeight: theme.typography.bodyLineHeight,
};

const dialogContentSx = {
  px: { xs: 2, sm: 2.5 },
  py: { xs: 1.75, sm: 2 },
  overflowY: "auto",
  maxHeight: { xs: "42vh", sm: "46vh" },
};

const dialogErrorListSx = {
  listStyle: "none",
  m: 0,
  p: 0,
  display: "flex",
  flexDirection: "column",
  gap: `${theme.spacing.xs}px`,
};

const dialogErrorItemSx = {
  display: "flex",
  alignItems: "flex-start",
  gap: `${theme.spacing.xs}px`,
  px: 1.25,
  py: 1,
  borderRadius: `${theme.radius.small}px`,
  backgroundColor: theme.colors.highlightSoft,
  border: `1px solid ${theme.colors.primaryBorder}`,
};

const dialogErrorBulletSx = {
  width: 7,
  height: 7,
  borderRadius: "50%",
  backgroundColor: theme.colors.highlight,
  flexShrink: 0,
  mt: "0.45rem",
};

const dialogErrorTextSx = {
  color: theme.colors.textPrimary,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.bodySize,
  lineHeight: 1.45,
  fontWeight: theme.typography.weightSemibold,
  wordBreak: "break-word",
};

const dialogBodyTextSx = {
  color: theme.colors.textSecondary,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.bodySize,
  lineHeight: 1.5,
  whiteSpace: "pre-line",
  wordBreak: "break-word",
};

const dialogActionsSx = {
  px: { xs: 2, sm: 2.5 },
  py: { xs: 1.5, sm: 2 },
  justifyContent: { xs: "stretch", sm: "flex-end" },
  gap: 1,
};

const dialogPrimaryButtonSx = {
  textTransform: "none",
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.weightSemibold,
  borderRadius: `${theme.radius.medium - 2}px`,
  backgroundColor: theme.colors.primary,
  color: theme.colors.white,
  border: `1px solid ${theme.colors.primary}`,
  minHeight: 42,
  minWidth: { xs: "100%", sm: 112 },
  px: 2.5,
  transition: theme.motion.transition,
  "&:hover": {
    backgroundColor: theme.colors.white,
    color: theme.colors.primary,
    borderColor: theme.colors.primary,
  },
  "&:active": {
    backgroundColor: theme.colors.white,
    color: theme.colors.primary,
    borderColor: theme.colors.primary,
    opacity: 0.92,
  },
  "&.Mui-focusVisible": {
    outline: `2px solid ${theme.colors.highlight}`,
    outlineOffset: 2,
  },
  "&.Mui-disabled": {
    backgroundColor: theme.colors.switchTrackDisabled,
    color: theme.colors.textSecondary,
    borderColor: theme.colors.switchTrackDisabled,
  },
};
